import {
  NotificationIcon as CoreNotificationIcon,
  useSession,
} from '@zhiyue/core';
import React from 'react';
import { fetchOpenPlatformToken } from '@/services/openPlatformToken';

type NotificationIconProps = Omit<
  React.ComponentProps<typeof CoreNotificationIcon>,
  'token'
>;

const NotificationIcon: React.FC<NotificationIconProps> = (props) => {
  const { currentUser, loading } = useSession();
  const [token, setToken] = React.useState('');

  React.useEffect(() => {
    if (loading || !currentUser?.memberUuid) {
      setToken('');
      return;
    }
    let cancelled = false;
    void fetchOpenPlatformToken({
      tenantUuid: currentUser.tenantUuid,
      organizationUuid: (currentUser as typeof currentUser & { organizationUuid?: string }).organizationUuid,
      memberUuid: currentUser.memberUuid,
    })
      .then((result) => {
        if (!cancelled) setToken(result.accessToken);
      })
      .catch(() => {
        if (!cancelled) setToken('');
      });
    return () => {
      cancelled = true;
    };
  }, [currentUser, loading]);

  if (loading || !currentUser?.memberUuid || !token) {
    return null;
  }

  return <CoreNotificationIcon {...props} token={token} />;
};

export default NotificationIcon;
